export const resetAppCache = async () => {
  try {
    localStorage.setItem(
      'lastCacheRefresh',
      JSON.stringify({
        version: global.appVersion,
        timestamp: Date.now(),
      }),
    );
  } catch (e) {
    // localStorage can fail in private mode / quota exceeded — proceed anyway
  }

  if ('serviceWorker' in navigator) {
    try {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map((r) => r.unregister()));
    } catch (error) {
      console.warn('Error unregistering service workers:', error);
    }
  }

  if ('caches' in window) {
    try {
      const keys = await caches.keys();
      await Promise.all(keys.map((name) => caches.delete(name)));
    } catch (error) {
      console.warn('Error clearing caches:', error);
    }
  }

  window.location.href =
    window.location.href.split('?')[0] + '?v=' + Date.now();
};
